import { useQuery } from "@apollo/client";
import React, { useState } from "react";
import { LISTAR_SUBTIPO_EGRESOS } from "../../../graphql/bancos";
import Scrollbar from "../../../components/Scrollbar";
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TablePagination,
  TableRow,
} from "@mui/material";
import MovimientosHeader from "../../../components/TableHeader/MovimientosHeader";
import Iconify from "../../../components/Iconify";
import FrmEditarConceptosBanco from "./Forms/FrmEditarConceptos";
const TABLE_HEADER = [
  { id: "copcepto", label: "Concepto", alignRight: false },
  { id: "tipo", label: "Tipo Concepto", alignRight: false },
  { id: "", label: "", alignRight: false },
];

const ConceptosTablaBanco = ({
  setOpenDialog,
  setBodyDialog,
  setErrorGraph,
  setOpenSnackBar,
}) => {
  const { data, loading, error } = useQuery(LISTAR_SUBTIPO_EGRESOS);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  if (loading) {
    return <h1>Cargando informacio´n...</h1>;
  }
  const { obtenerConceptoBancos } = data;
  //Longitud
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleEditData = (e) => {
    setBodyDialog(
      <FrmEditarConceptosBanco
        setOpenDialog={setOpenDialog}
        setErrorGraph={setErrorGraph}
        setOpenSnackBar={setOpenSnackBar}
        id={e}
      />
    );
    setOpenDialog(true);
  };
  return (
    <>
      <Scrollbar>
        <Table>
          <MovimientosHeader headLabel={TABLE_HEADER} />
          <TableBody>
            {obtenerConceptoBancos
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row) => {
                const { id, concepto, TipoConceptoId } = row;
                return (
                  <TableRow hover key={id} tabIndex={-1}>
                    <TableCell>{concepto}</TableCell>
                    <TableCell>{TipoConceptoId}</TableCell>
                    <TableCell>
                      <Button
                        value={id}
                        onClick={(e) => {
                          handleEditData(id);
                        }}
                        startIcon={<Iconify icon="eva:edit-2-outline" />}
                      >
                        Editar
                      </Button>
                      {/* {baja ? (
                        <>
                          <Button
                            color="primary"
                            value={id}
                            startIcon={<Iconify icon="eva:checkmark-outline" />}
                            onClick={(e) => {
                             // handleActiveteRecord(id);
                            }}
                          >
                            Activar
                          </Button>
                          <Button
                            value={id}
                            onClick={(e) => {
                            //  handleDeleteRecord(id);
                            }}
                            color="error"
                            startIcon={<Iconify icon="eva:close-outline" />}
                          >
                            Eliminar
                          </Button>
                        </>
                      ) : (
                        <Button
                          value={id}
                          onClick={(e) => {
                           // handleDeactivateRecord(id);
                          }}
                          color="error"
                          startIcon={<Iconify icon="eva:close-outline" />}
                        >
                          Desactivar
                        </Button>
                      )} */}
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </Scrollbar>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        page={page}
        count={obtenerConceptoBancos.length}
        rowsPerPage={rowsPerPage}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </>
  );
};

export default ConceptosTablaBanco;
